
    (function () {
        const ROOT_SELECTOR = '#wccp-composite-root, .wccp-composite-root';
        const OVERLAY_CLASS = 'wccp-root-overlay';
 
        if (window.__wccpPreloaderInit) return;
        window.__wccpPreloaderInit = true;

        function waitFor(selector, timeout = 20000) {
            return new Promise((resolve, reject) => {
                const now = document.querySelector(selector);
                if (now) return resolve(now);
                const mo = new MutationObserver(() => {
                    const el = document.querySelector(selector);
                    if (el) { mo.disconnect(); resolve(el); }
                });
                mo.observe(document.documentElement, { childList: true, subtree: true });
                if (timeout) setTimeout(() => { mo.disconnect(); reject(new Error('waitFor timeout')); }, timeout);
            });
        }

        function mountOverlay(root) {
            if (getComputedStyle(root).position === 'static') root.style.position = 'relative';
            if (!document.getElementById('wccp-root-overlay-style')) {
                const s = document.createElement('style');
                s.id = 'wccp-root-overlay-style';
                s.textContent = `
        .${OVERLAY_CLASS}{
          position:absolute; inset:0;
          display:none; align-items:center; justify-content:center;
          background:rgba(255,255,255,0.6);
          z-index:99999; pointer-events:all;
        }
        .${OVERLAY_CLASS}.is-active{ display:flex; }`;
                document.head.appendChild(s);
            }
            let overlay = root.querySelector('.' + OVERLAY_CLASS);
            if (!overlay) {
                overlay = document.createElement('div');
                overlay.className = OVERLAY_CLASS;
                overlay.innerHTML = `<div class="wccp-constructor-preloader" role="status" aria-label="Loading"></div>`;
                root.appendChild(overlay);
            }
            return overlay;
        }

        function init(root) {
            const overlay = mountOverlay(root);
            let inflight = 0;
            const show = () => overlay.classList.add('is-active');
            const hide = () => overlay.classList.remove('is-active');
            const inc  = () => { if (++inflight === 1) show(); };
            const dec  = () => { inflight = Math.max(0, inflight - 1); if (inflight === 0) hide(); };

            // Only the builder's own admin-ajax calls (all fetch, action=wccp_*) block the UI. Wrapping every
            // fetch/XHR/jQuery request also froze it for Google Ads/Analytics, Stripe and UTM tracking calls.
            if (!window.__wccpFetchWrapped && typeof window.fetch === 'function') {
                window.__wccpFetchWrapped = true;
                const _fetch = window.fetch.bind(window);
                // Background prefetches (prefetch=1) must not block the step the customer is looking at.
                const isBuilderRequest = (init) => { const b = String((init && init.body) || ''); return /(^|&)action=wccp_/.test(b) && !/(^|&)prefetch=1/.test(b); };
                window.fetch = function(input, init) {
                    if (!isBuilderRequest(init)) return _fetch.apply(this, arguments);
                    inc();
                    return Promise.resolve(_fetch.apply(this, arguments))
                        .then(r => { dec(); return r; }, e => { dec(); throw e; });
                };
            }

            window.WCCP_LOADING = {
                start: () => inc(),
                stop:  () => dec(),
                active: () => inflight > 0
            };
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                waitFor(ROOT_SELECTOR).then(init).catch(() => {});
            }, { once: true });
        } else {
            waitFor(ROOT_SELECTOR).then(init).catch(() => {});
        }
    })();